import {
  COMPLETE_USER_SUBMISSION_FAIL,
  COMPLETE_USER_SUBMISSION_REQUEST,
  COMPLETE_USER_SUBMISSION_SUCCESS,
  GET_CERTIFICATE_PUBLIC_URL_FAIL,
  GET_CERTIFICATE_PUBLIC_URL_REQUEST,
  GET_CERTIFICATE_PUBLIC_URL_SUCCESS,
  GETALL_SUBMITTEDUSERS_FAIL,
  GETALL_SUBMITTEDUSERS_REQUEST,
  GETALL_SUBMITTEDUSERS_SUCCESS,
} from "../../constants/Admin-Panels/adminPanelConstants";
import { APIRequestURI } from "../../utils/api_request_uri";
import axios from "axios";

export const getAllSubmittedUsersAction =
  (certificate_status) => async (dispatch, getState) => {
    try {
      dispatch({ type: GETALL_SUBMITTEDUSERS_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };
      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/submission/superadmin/allsubmissions`,
        { certificate_status },
        config
      );

      dispatch({
        type: GETALL_SUBMITTEDUSERS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GETALL_SUBMITTEDUSERS_FAIL,
        payload: error.message,
      });
    }
  };

export const completeUserSubmissionAction =
  (user, issuing_date, certified_for, registration_id) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: COMPLETE_USER_SUBMISSION_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };
      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/certification/certificate-pdf`,
        {
          recipientName: `${user?.firstName || ""} ${
            user?.lastName || ""
          }`.trim(),
          description: "",
          issuing_date: issuing_date,
          certified_for: certified_for,
          registrationId: registration_id,
        },
        config
      );

      dispatch({
        type: COMPLETE_USER_SUBMISSION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: COMPLETE_USER_SUBMISSION_FAIL,
        payload: error.message,
      });
    }
  };

export const getCertificatePublicUrlAction =
  (user, issuing_date, certified_for) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_CERTIFICATE_PUBLIC_URL_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };
      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/certification/certificate-pdf`,
        {
          recipientName: `${user?.firstName || ""} ${
            user?.lastName || ""
          }`.trim(),
          description: "",
          issuing_date: issuing_date,
          certified_for: certified_for,
        },
        config
      );

      dispatch({
        type: GET_CERTIFICATE_PUBLIC_URL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_CERTIFICATE_PUBLIC_URL_FAIL,
        payload: error.message,
      });
    }
  };
